import { render, staticRenderFns } from "./AuctionBidding.vue?vue&type=template&id=2f10bc36&"
import script from "./AuctionBidding.vue?vue&type=script&lang=js&"
export * from "./AuctionBidding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports